{
  "0_ALREADY_EXISTS": "\"{0}\" zaten mevcut.",
  "0_OF_1": "{1} öğeden {0}",
  "ACCOUNT_ID": "Hesap Kimliği",
  "ADD": "Ekle",
  "ADD_REMOVE_FIELDS": "Alan ekle/kaldır",
  "AN_ERROR_OCCURED": "Bir hata oluştu",
  "APPLY": "Uygula",
  "APPLY_CHANGES": "Değişiklikleri uygula",
  "ATTACH": "Ekle",
  "ATTACH_AS_LINK": "Bağlantı olarak ekle",
  "ATTACHING": "Ekleniyor...",
  "AUTOMATICALLY_RENAME": "Otomatik yeniden adlandır",
  "BACK": "Geri",
  "BROWSE": "Gözat",
  "CANCEL": "İptal",
  "CHARACTER_COUNT": "Karakter sayısı:",
  "CLOSE": "Kapat",
  "CLOUD": "Bulut",
  "COMMENT": "Yorum",
  "CONFIGURE_REPOSITORY_SETTINGS": "Depo Ayarlarını Yapılandır",
  "COULD_NOT_SAVE_0": "\"{0}\" kaydedilemedi.",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "\"{0}\" kaydedilemedi. Dosya türü desteklenmiyor.",
  "DATA": "Veri",
  "DATE": "Tarih",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Tarih alanları {0} formatında olmalıdır.",
  "DATE_PROVIDED_IS_INVALID": "Girilen tarih geçersiz.",
  "DATE_TIME": "Tarih/Saat",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Tarih/saat alanları {0} formatında olmalıdır.",
  "DEFAULT_FOLDER": "<Varsayılan Klasör>",
  "DETAILS": "Detaylar",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Alan değişikliklerinizi uygulamak istiyor musunuz?",
  "DOCUMENT_NAME_IS_EMPTY": "Belge adı boş",
  "DRAG_DROP_FILE": "Dosyayı sürükleyip bırakın",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Bu klasörde '{0}' adlı bir giriş zaten mevcut. Lütfen farklı bir ad seçin.",
  "ENTRY_ID": "Giriş Kimliği",
  "ENTRY_NAME": "Girdi Adı",
  "ENTRY_NOT_FOUND": "Giriş bulunamadı.",
  "ERROR_DOWNLOADING_DOCUMENT": "Belge indirilirken hata oluştu.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Sunucuya bağlanırken bir hata oluştu.",
  "ERROR_SAVING": "Kaydetme hatası:",
  "FAILED_TO_OPEN_FOLDER": "Klasör açılamadı",
  "FAILED_TO_SAVE_COLON": "Kaydetme başarısız:",
  "FAILED_TO_SAVE_PERIOD": "Kaydetme başarısız.",
  "FEEDBACK": "Geri bildirim",
  "FIELDS": "Alanlar",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Bu dosya 25MB maksimum dosya boyutunu aşıyor.",
  "FILE_EXTENSION": "Dosya Uzantısı",
  "FILE_LOCKED": "Dosya kilitli.",
  "FILE_MODIFIED": "Dosya Değiştirildi",
  "FILE_NAME": "Dosya Adı",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Dosya adları ters eğik çizgi içeremez",
  "FOLDER": "Klasör",
  "INTEGER": "Tam sayı",
  "LIST": "Liste",
  "LOADING": "Yükleniyor...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Long alanlar 0 ile 3.999.999.999 arasında tam sayı olmalıdır",
  "LONG_INTEGER": "Uzun Tamsayı",
  "NAME": "İsim",
  "NAME_CONFLICT": "İsim Çakışması",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Giriş yaparken yardıma mı ihtiyacınız var? Yardım için Laserfiche Yöneticinizle iletişime geçin.",
  "NEW_FOLDER": "Yeni Klasör",
  "NO": "Hayır",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Ek alan atanmadı",
  "NO_FOLDER_SELECTED": "Hiçbir klasör seçilmedi.",
  "NO_MATCHING_ENTRIES_FOUND": "Eşleşen kayıt bulunamadı",
  "NO_MATCHING_FIELDS_FOUND": "Eşleşen alan bulunamadı.",
  "NO_TEMPLATE_ASSIGNED": "Şablon atanmamış",
  "NOT_AVAILABLE_WITH_TOKENS": "Jetonlarla kullanılamaz",
  "NUMBER": "Sayı",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Sayı alanı geçerli bir sayı olmalıdır",
  "OK": "Tamam",
  "ONE_OR_MORE_FIELDS_INVALID": "Bir veya daha fazla alan geçersiz.",
  "OPEN": "Aç",
  "OPEN_IN_LASERFICHE": "Laserfiche'de aç",
  "OPTIONAL": "İsteğe bağlı",
  "OR": "veya",
  "PARENT_FIELD": "Üst Alan",
  "PARENT_ID": "Üst Kimlik",
  "PARENT_NAME": "Üst Dizin Adı",
  "PLEASE_SELECT_A_FOLDER": "Lütfen bir klasör seçin",
  "REASON_FOR_DOWNLOADING": "İndirme Nedeni",
  "REFRESH": "Yenile",
  "REMOVE": "Kaldır",
  "REMOVE_REPOSITORY": "Depo kaldırılsın mı?",
  "REPOSITORY": "Depo",
  "REPOSITORY_COUNT": "Depo Sayısı",
  "REPOSITORY_ID": "Depo Kimliği",
  "REPOSITORY_NAME": "Depo Adı",
  "REQUIRED": "Gerekli",
  "REQUIRED_FIELD_IS_EMPTY": "Gerekli alan boş",
  "SAVE_CHANGES": "Değişiklikleri Kaydet",
  "SAVE_TO_LASERFICHE": "Laserfiche'e kaydet",
  "SAVED_TO_LASERFICHE": "Laserfiche'e kaydedildi",
  "SAVED_TO_LASERFICHE_COLON": "Laserfiche'e kaydedildi:",
  "SAVED_WITH_MISSING_METADATA": "Eksik meta verilerle kaydedildi:",
  "SAVING": "Kaydediliyor...",
  "SEARCH_FIELDS": "Arama alanları",
  "SELECT": "Seç",
  "SELECT_REASON": "Bir neden seçin",
  "SELF_HOSTED": "Kendi Sunucusunda Barındırılan",
  "SESSION_COUNT": "Oturum Sayısı",
  "SETTINGS": "Ayarlar",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Kısa alanlar 0 ile 64999 arasında tam sayı olmalıdır",
  "SIGN_IN": "Giriş yap",
  "SIGN_IN_TO_LASERFICHE": "Laserfiche'e giriş yapın",
  "SIGN_OUT": "Oturumu kapat",
  "SIGNING_IN": "Giriş yapılıyor...",
  "SIGNING_OUT": "Oturum kapatılıyor...",
  "SKIP_THIS_FILE": "Bu dosyayı atla",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin.",
  "SUBMIT": "Gönder",
  "SUGGESTION": "Öneri",
  "TEMPLATE": "Şablon",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Şablon yüklenemedi.",
  "TEXT": "Metin",
  "THANK_YOU_FOR_SUBMISSION": "Gönderiniz için teşekkür ederiz!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Bu alanın izin verilen maksimum uzunluğu {0} karakterdir.",
  "THIS_FOLDER_IS_EMPTY": "Bu klasör boş.",
  "TIME": "Zaman",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Zaman alanları {0} formatında olmalıdır.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Tüm alanlar yüklenemedi:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Depo bilgileri alınamıyor:",
  "UNKNOWN_ERROR": "Bilinmeyen Hata.",
  "USER_NAME": "Kullanıcı Adı",
  "YES": "Evet"
}
